import { FC, ReactNode } from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from 'components/button';
import Box from '@material-ui/core/Box';

export interface ConfirmModalProps {
  open: boolean;
  title?: string;
  content: ReactNode;
  footer?: ReactNode;
  okText?: string;
  cancelText?: string;
  onCancel?: () => void;
  onOk?: () => void;
}

export const ConfirmModal: FC<ConfirmModalProps> = ({
  open,
  title,
  content,
  footer,
  okText = 'Yes',
  cancelText = 'No',
  onCancel,
  onOk,
}) => {
  const handleOk = () => {
    onOk?.();
    onCancel?.();
  };

  return (
    <Dialog open={open} onClose={onCancel}>
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        {footer || (
          <Box display="flex" gridGap={16} px={2} py={1}>
            {!!onCancel && (
              <Button size="small" onClick={onCancel} variant="outlined">
                {cancelText}
              </Button>
            )}
            {!!onOk && (
              <Button size="small" onClick={handleOk} variant="contained" autoFocus>
                {okText}
              </Button>
            )}
          </Box>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmModal;
